import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";

import Vue from "vue";

import "./styles/quasar.scss";
import "quasar/dist/quasar.ie.polyfills";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import { Quasar } from "quasar";

import Vuelidate from "vuelidate";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import App from "@/app.vue";
import VueSweetalert2 from "vue-sweetalert2";
// import "@/common/registerServiceWorker";

import VueResource from "vue-resource";
import helpers from "@/plugins/helpers";

Vue.config.productionTip = process.env.NODE_ENV === "production" || false;

Vue.use(Quasar, {
  config: {},
  components: {
    /* not needed if importStrategy is not 'manual' */
  },
  directives: {
    /* not needed if importStrategy is not 'manual' */
  },
  plugins: {}
});

Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.use(helpers, { $store: store, $router: router, $t: i18n, $swal: Vue.swal });

import dayjs from "dayjs";
Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs });

/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  let query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
  let path = "/denied";

  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn && record.meta.includedPages;
    })
  ) {
    if (!store.getters.isLoggedIn) {
      next({ path: path, query: query });
      return;
    }
  }
  next();
});

i18n.locale = store.state.layout.language;
// i18n.locale = "zh";

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
